import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CardModule } from 'primeng/card';
import { DatePipe } from '@angular/common';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { PhoneRoutingModule } from './phone-routing.module';
import { PhoneSidebarComponent } from './phone-sidebar/phone-sidebar.component';
import { ToastModule } from 'primeng/toast';
import { PhoneCallAlertComponent } from './phone-call-alert/phone-call-alert.component';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';

import { CoreModule } from 'src/app/core/core.module';
@NgModule({
  declarations: [
    PhoneSidebarComponent,
    PhoneCallAlertComponent
  ],
  imports: [
    CoreModule,
    FormsModule,
    PhoneRoutingModule,
    BrowserModule,
    CardModule,
    TableModule,
    ConfirmDialogModule,
    InputTextModule,
    DropdownModule,
    DatePipe,
    TabViewModule,
    ButtonModule,
    ToastModule,
    MessagesModule,
    MessageModule
  ],
  exports: [
    PhoneSidebarComponent,
    PhoneCallAlertComponent
  ],
  providers: []
})
export class PhoneModule {
}
